import React from "react";
import { BookOpenIcon, GiftIcon, WrenchIcon, FlameIcon } from "lucide-react";
import { CTAButton } from "../CTAButton";
import { Countdown } from "../Countdown";
import { images } from "../../data/content";
const stats = [{
  icon: BookOpenIcon,
  value: "6",
  label: "Premium volumes"
}, {
  icon: GiftIcon,
  value: "5",
  label: "Exclusive bonuses"
}, {
  icon: WrenchIcon,
  value: "30+",
  label: "Planning tools"
}];
export function Hero() {
  return <header className="relative w-full overflow-hidden bg-ink" data-id="element-159" data-mp="mrxxu204tqns">
      <div className="bg-alert px-4 py-2.5 text-center font-display text-[13px] font-extrabold uppercase tracking-wide text-white sm:text-sm" data-id="element-160" data-mp="qub4csmpdslm">
        <FlameIcon className="mr-1 inline h-4 w-4 -translate-y-px" aria-hidden data-id="element-161" data-mp="voosqb2y6zgs" />
        Limited launch offer — everything for just $27 USD
      </div>

      <div className="mx-auto grid max-w-6xl items-center gap-8 px-4 pb-14 pt-8 sm:pt-12 lg:grid-cols-[1.05fr_1fr] lg:gap-12 lg:pb-20" data-id="element-162" data-mp="15ll5wu3sk9ro">
        <div className="text-center lg:text-left" data-id="element-163" data-mp="1ahiluzb57e3x">
          <p className="text-sm font-semibold text-brand" data-id="element-164" data-mp="9o2ori93aklh">By Dr. Alexander Hayes</p>
          <h1 className="mt-3 font-display text-[30px] font-black leading-[1.08] tracking-tight text-white sm:text-5xl lg:text-[54px]" data-id="element-165" data-mp="4o6l5k4b0v6g">
            Plan Your Next Post-Endodontic Restoration in{" "}
            <span className="text-cta" data-id="element-166" data-mp="3rtxjlx5z2049">15 Minutes</span> — With a Clearer Clinical Decision-Making Process.
          </h1>
          <p className="mx-auto mt-5 max-w-xl text-[17px] leading-relaxed text-mist lg:mx-0" data-id="element-167" data-mp="sd920pr46jzw">
            A practical, step-by-step educational system designed to help you evaluate endodontically treated teeth, assess the remaining tooth structure, and organize your restorative treatment plan with greater clarity.
          </p>

          <div className="mt-6 grid grid-cols-3 gap-2 sm:gap-3 lg:max-w-lg" data-id="element-168" data-mp="emnj511nua20">
            {stats.map(s => <div key={s.label} className="rounded-xl border border-line bg-panel/70 px-2 py-3 text-center" data-id="element-169" data-mp="1b6mqqd48hu72">
                <s.icon className="mx-auto h-5 w-5 text-brand" aria-hidden data-id="element-170" data-mp="30lxd88v728w6" />
                <p className="mt-1 font-display text-2xl font-black text-white" data-id="element-171" data-mp="30o0e5nxvxmfo">{s.value}</p>
                <p className="text-[11px] font-semibold uppercase leading-tight text-mist" data-id="element-172" data-mp="35k8mahdo0fdc">{s.label}</p>
              </div>)}
          </div>
        </div>

        <div className="-mx-4 sm:mx-0" data-id="element-173" data-mp="2vu5m9x84m15i">
          <img src={images.mockup} alt="Post-Endodontic Restoration Blueprint: 6 volumes and 5 bonuses" className="mx-auto w-full max-w-2xl" data-id="element-174" data-mp="2vt483jvtcyjk" />
          <p className="mt-2 px-4 text-center text-sm font-semibold text-mist" data-id="element-175" data-mp="2mvu0q9m49tjx">
            The 6 Volumes and 5 Bonuses of Post-Endodontic Restoration Blueprint™
          </p>
        </div>

        <div className="flex flex-col items-center gap-6 lg:col-span-2" data-id="element-176" data-mp="2cwuxj6k4eq4b">
          <CTAButton id="first-cta" label="I want the Post-Endodontic Restoration Blueprint™" pulse data-id="element-177" data-mp="66y9eouy1kjl" />
          <Countdown data-id="element-178" data-mp="b3x356ap3ph9" />
          <p className="max-w-xl text-center text-[15px] text-mist" data-id="element-179" data-mp="b4gbbvajmzi3">
            <span className="font-bold text-white" data-id="element-180" data-mp="1vm8v4ie2xv7n">Get the complete system today for just $27 USD.</span> Immediate access to all 6 volumes and 5 exclusive bonuses.
          </p>
        </div>
      </div>
    </header>;
}